import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { MatSnackBar, MatDialogRef, MatDialog } from '@angular/material';
import { ProgressSpinnerDialogComponent } from '../progress-spinner-dialog/progress-spinner-dialog.component';
import { catchError, tap } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  constructor(private httpClient: HttpClient, private router: Router, private snackBar: MatSnackBar, private dialog: MatDialog) { }

  public authenticateUser(value) {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });
    return this.httpClient.post(environment.apiUrl + 'Authentication/login', value, {})
      .subscribe(response => {
        const token = (response as any).token;
        const role = (response as any).role;
        localStorage.setItem('jwt', token);
        localStorage.setItem('role', role);
        if (localStorage.getItem('role') === 'Administrator') {
          this.router.navigate(['welcome/']);
          dialogRef.close();
        } else {
          this.router.navigate(['welcome/']);
          dialogRef.close();
        }

      }, error => {
        var errorMsg = 'Error received from server.';
        if (error.status === 400){
          errorMsg = 'Invalid username and password';
        }
        dialogRef.close();
        this.snackBar.open( errorMsg, null, {
          duration: 2500,
          panelClass: ['global-error']
        });
      });
  }

  public register(value){
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });

    return this.httpClient.post(environment.apiUrl + 'Authentication/Register', value, {})
      .subscribe(response => {
        dialogRef.close();
        this.router.navigate(['login/']);
        this.snackBar.open("Registration successful.", null, {
          duration: 2500,
          //panelClass: ['global-error']
        });

      }, error => {
        dialogRef.close();
        this.snackBar.open('Error', null, {
          duration: 2500,
          panelClass: ['global-error']
        });
      });
  }

  contactUs(value: any) {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });

    return this.httpClient.post(environment.apiUrl + 'Authentication/ContactUs', value, {})
      .subscribe(response => {
        dialogRef.close();
        this.snackBar.open("Email sent", null, {
          duration: 2500,
          //panelClass: ['global-error']
        });

      }, error => {
        dialogRef.close();
        this.snackBar.open('Error', null, {
          duration: 2500,
          panelClass: ['global-error']
        });
      });
  }

  bulkEmail(value: any) {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });

    return this.httpClient.post(environment.apiUrl + 'Authentication/BulkEmail', value, {})
      .subscribe(response => {
        dialogRef.close();
        this.snackBar.open("Email sent", null, {
          duration: 2500,
          //panelClass: ['global-error']
        });

      }, error => {
        dialogRef.close();
        this.snackBar.open('Error', null, {
          duration: 2500,
          panelClass: ['global-error']
        });
      });
  }

  public forgetPassword(value) {
    let dialogRef: MatDialogRef<ProgressSpinnerDialogComponent> = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });

    return this.httpClient.post(environment.apiUrl + 'Authentication/ForgotPassword', value, {})
      .subscribe(response => {
        dialogRef.close();
        this.snackBar.open("Please check your email", null, {
          duration: 2500,
          //panelClass: ['global-error']
        });
        this.router.navigate(['login/']);

      }, error => {
        dialogRef.close();
        this.snackBar.open('Issue occured while trying to register, Please try again later', null, {
          duration: 2500,
          panelClass: ['global-error']
        });
      });
  }
  

  public getToken(): string {
    return localStorage.getItem('jwt');
  }

  public getUserRole(): string {
    return localStorage.getItem('role');
  }

  public resetPassword(userId: string, password: string) {
    let value = {
      userId: userId,
      password: password
    };
    return this.httpClient.post(environment.apiUrl + 'Authentication/ResetPassword', value, {}).pipe(
      tap(),
      catchError(this.handleError)
    );
  }
 
  public resetPasswordToken(value) {
    return this.httpClient.post(environment.apiUrl + 'Authentication/ResetPasswordToken', value).pipe(
      tap(),
      catchError(this.handleError)
    );
  }

  private handleError(error: HttpErrorResponse) {
    console.log(error);
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
      errorMessage = error.error.error.errors;
    }
    // return an observable with a user-facing error message
    return throwError(
      errorMessage);
  }
}
